import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Button } from "antd";
import moment from "moment";
import AttendenceModelPopup from "../../../components/modelpopup/AttendenceModelPopup";
import axios from "axios"; // Add axios for API calls
import { Avatar_02 } from "../../../Routes/ImagePath";
import { Avatar_01 } from "../../../Routes/ImagePath";
import ReportingSelect from "../../../components/ReportingSelect";
import { useGlobalData } from "../../context/GlobalDataContext";  // Import the global context
import * as XLSX from "sheetjs-style";

const AttendanceAdmin = () => {
  const [selectedDate, setSelectedDate] = useState(moment());
  const [attendanceData, setAttendanceData] = useState([]);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [daysInMonth, setDaysInMonth] = useState(31); // default to 31 days
  const [selectedEmployee, setSelectedEmployee] = useState(null); // State for selected employee
  const [selectedDay, setSelectedDay] = useState(null); // State for selected day
  const [dayStatus, setDayStatus] = useState("normal"); // State for day status
  const [isFullScreen, setFullScreen] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");
  const maximizeBtnRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const cdnUrl = process.env.REACT_APP_CDN_URL;
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [selectedEmployeeLabel, setSelectedEmployeeLabel] = useState( null);





  const handleExport = () => {
    const workbook = XLSX.utils.book_new();
  
    // Header Information
    const companyName = "XYZ Company Name";
    const monthYear = selectedDate.format("MMMM YYYY");
    const sheetHeading = `Monthly Attendance Sheet ${monthYear}`;
  
    // Add header rows
    const headerData = [
      [`${companyName}`], // First row: Company Name
      [`${sheetHeading}`], // Second row: Attendance Heading
      [
        "Emp Name",
        "Emp Code",
        ...Array.from({ length: daysInMonth }, (_, i) => i + 1),
        "Total Working Days",
        "Days Worked",
        "Leaves",
        "LOP Days",
      ], // Table headers
    ];
  
    // Prepare attendance data
    const tableBody = filteredData.map((employee) => {
      const totalDays = calculatePayrollData(employee).totalDays;
      const daysWorked = calculatePayrollData(employee).daysWorked;
      const leaves = calculatePayrollData(employee).leaves;
      const lopDays = calculatePayrollData(employee).lopDays;
  
      return [
        employee.name,
        employee.empcode,
        ...Array.from({ length: daysInMonth }, (_, i) => {
          const day = i + 1;
          const date = moment(`${selectedDate.format("YYYY-MM")}-${day}`, "YYYY-MM-DD");
          const isWeekend = weekends.includes(date.day());
          const isHoliday = holidays.includes(date.format("YYYY-MM-DD"));
  
          if (isHoliday) return "H"; // Holiday
          if (isWeekend) return "W"; // Weekend
          const dayValue = employee[`day_${day}`];
          if (dayValue === "A") return "A"; // Absent
          if (dayValue === "P") return "P"; // Present
          return "-"; // Default
        }),
        totalDays || "-", // Total Working Days
        daysWorked || "-", // Days Worked
        leaves || "-", // Leaves
        lopDays || "-", // LOP Days
      ];
    });
  
    // Combine headers and body
    const sheetData = [...headerData, ...tableBody];
  
    // Create worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
  
    // Merged cells for headers
    worksheet["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: daysInMonth + 4 } }, // Company Name merged
      { s: { r: 1, c: 0 }, e: { r: 1, c: daysInMonth + 4 } }, // Attendance Heading merged
    ];
  
    // Column Widths
    worksheet["!cols"] = [
      { wch: 20 }, // Emp Name
      { wch: 15 }, // Emp Code
      ...Array.from({ length: daysInMonth }, () => ({ wch: 5 })), // Day columns
      { wch: 15 }, // Total Working Days
      { wch: 12 }, // Days Worked
      { wch: 10 }, // Leaves
      { wch: 10 }, // LOP Days
    ];
  
    // Apply styles for all cells
    Object.keys(worksheet).forEach((cellAddress) => {
      if (!cellAddress.startsWith("!")) {
        worksheet[cellAddress].s = {
          font: { name: "Arial", bold: false, sz: 10 },
          alignment: { horizontal: "center", vertical: "center" },
          border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          },
        };
      }
    });
  
    // Styles for Company Name
    worksheet["A1"].s = {
      font: { bold: true, sz: 18 },
      alignment: { horizontal: "left", vertical: "center" },
    };
  
    // Styles for Attendance Heading
    worksheet["A2"].s = {
      font: { bold: true, sz: 16 },
      alignment: { horizontal: "left", vertical: "center" },
    };
  
    // Styles for column headers
    headerData[2].forEach((_, index) => {
      const cellAddress = XLSX.utils.encode_cell({ r: 2, c: index });
      worksheet[cellAddress].s = {
        font: { bold: true, sz: 12 },
        alignment: { horizontal: "center", vertical: "center" },
        border: {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        },
      };
    });
  
    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Monthly Attendance");
  
    // Export workbook
    XLSX.writeFile(workbook, `Attendance_${monthYear}.xlsx`);
  };
  
  
  
  
  
  
  

  const {
    holidays,
    weekends,
    weekStart,
    weekEnd,
    additionalOffDays,
    workingHours,
    loading: globalLoading,
  } = useGlobalData();  // Access the global data


  useEffect(() => {
    if (attendanceData.length > 0) {
      if (selectedEmployeeId) {
        const filtered = attendanceData.filter(item => item.empid === selectedEmployeeId);
        setFilteredData(filtered);
      } else {
        setFilteredData(attendanceData); // Default to all data if no employee selected
      }
    }
  }, [attendanceData, selectedEmployeeId]);


  useEffect(() => {
    const handleClick = () => {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
        setFullScreen(true);
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
          setFullScreen(false);
        }
      }
    };

    const cleanup = () => {
      if (isFullScreen && document.exitFullscreen) {
        document.exitFullscreen();
        setFullScreen(false);
      }
    };

    const maximizeBtn = maximizeBtnRef.current;
    maximizeBtn.addEventListener('click', handleClick);

    return () => {
      maximizeBtn.removeEventListener('click', handleClick);
      cleanup();
    };
  }, [isFullScreen]);

  const fetchData = async (month, year) => {
    try {
      setLoading(true);

      const response = await axios.get(`${apiUrl}/attendance/list-monthly`, {
        params: { month, year },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      setAttendanceData(response.data);
      setDaysInMonth(moment(`${year}-${month}`, "YYYY-MM").daysInMonth());
      setLoading(false);

    } catch (error) {
      console.error("Error fetching attendance data", error);
    }
  };

  useEffect(() => {
    const month = selectedDate.format("MM");
    const year = selectedDate.format("YYYY");
    fetchData(month, year);
  }, [selectedDate]);

  const handlePrevMonth = () => {
    setSelectedDate(prevDate => prevDate.clone().subtract(1, 'months'));
  };

  const handleNextMonth = () => {
    setSelectedDate(prevDate => prevDate.clone().add(1, 'months'));
  };

  const calculatePayrollData = (employee) => {
    let totalDays = daysInMonth;
    let daysWorked = 0;
    let leaves = 0;
    let lopDays = 0;

    for (let i = 1; i <= daysInMonth; i++) {
      const dayStatus = employee[`day_${i}`];
      if (dayStatus === "W") {
        continue; // Weekends are not counted in days worked or leaves
      } else if (dayStatus === "L") {
        leaves++;
      } else if (dayStatus === "A") {
        lopDays++;
      } else if (dayStatus === "P") {
        daysWorked++;
      }
    }

    return { totalDays, daysWorked, leaves, lopDays };
  };

  const handleDayClick = (employee, day, isWeekend, isHoliday) => {
    const selectedFullDate = moment(`${selectedDate.format("YYYY-MM")}-${day}`, "YYYY-MM-DD").format("YYYY-MM-DD");
  
    setSelectedEmployee(employee);
    setSelectedDay(selectedFullDate); // Pass the full date
  
    if (isHoliday) {
      setDayStatus("holiday");
    } else if (isWeekend) {
      setDayStatus("weekend");
    } else if (employee[`day_${day}`] === "-") {
      setDayStatus("normalnodata");
    } else {
      setDayStatus("normal");
    }
  };


    // Callback function to update the attendance data after saving
  

    const updateAttendanceDataForDay = (updatedData) => {
      setAttendanceData((prevData) =>
        prevData.map((employee) => {
          if (employee.empid === selectedEmployee.empid) {
            // Update the specific day in the employee's data
            return {
              ...employee,
              [`day_${moment(updatedData.date).date()}`]: updatedData.newStatus,
            };
          }
          return employee;
        })
      );
    };
  
    const handleEmployeeChange = (selectedOption) => {
      if (selectedOption && selectedOption.value !== "all") {
        const { value, label } = selectedOption;
        setSelectedEmployeeId(value);
        setSelectedEmployeeLabel(label);

        // Filter the data based on the selected employee
        const filtered = attendanceData.filter((item) => item.empid === value);
        setFilteredData(filtered); // Correctly set the filtered data
      } else {
        // Show all employees if "Show All" is selected
        setSelectedEmployeeId(null);
        setSelectedEmployeeLabel("Show All");
        setFilteredData(attendanceData); // Reset to the full data set
      }
    };
    

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">

        <div className="page-header page-top-icons">
            <div className="row align-items-center">
            <div className="col-md-4">

            <ReportingSelect
  value={selectedEmployeeId ? { value: selectedEmployeeId, label: selectedEmployeeLabel } : null}
  onChange={handleEmployeeChange}
/>

</div>
              <div className="col-md-4">
                <Button className="fa fa-chevron-circle-left" onClick={handlePrevMonth} />
                <span style={{ margin: '0 10px', fontWeight: 'bold', fontSize: '16px' }}>
                  {selectedDate.format('MMMM YYYY')}
                </span>
                <Button className="fa fa-chevron-circle-right" onClick={handleNextMonth} />
              </div>
              <div className="col-md-4 float-end ms-auto">
                <div className="d-flex title-head">
                  <div className="view-icons">
                  <Link to="#" className="grid-view btn btn-link" onClick={handleExport}>
                    <i className="las la-file-export" />
                  </Link>
                    <Link to="#" className="grid-view btn btn-link"><i className="las la-redo-alt" /></Link>
                    <Link to="#" className="list-view btn btn-link" id="collapse-header" ref={maximizeBtnRef}><i className="las la-expand-arrows-alt" /></Link>
                  </div>
                 
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="table-responsive">
                {loading ? (
                  <div id="loader-wrapper-">
                    <div className="loader">
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                    </div>
                  </div>
                ) : (
                  <>

                  
<div className="table-responsive table-fixed-columns" key={filteredData.map(item => item.empid).join(",")}>
  <table className="table table-striped custom-table table-nowrap mb-0">
    <thead>
      <tr>
        <th className="fixed-column name-column">Emp Name</th>
        <th className="fixed-column code-column">Emp Code</th>
        {Array.from({ length: daysInMonth }, (_, i) => (
          <th key={i + 1}>{i + 1}</th>
        ))}
        <th>Total Days</th>
        <th>Days Worked</th>
        <th>Leaves</th>
        <th>LOP Days</th>
      </tr>
    </thead>
    <tbody>
      {filteredData.map((employee) => {
        const payrollData = calculatePayrollData(employee);
        return (
          <tr key={employee.empid}>
            <td className="fixed-column name-column">
              <span className="table-avatar">
                <Link to={`/profile/${employee.empid}`} className="avatar">
                  <img
                    src={
                      employee.profile_pic
                        ? `${cdnUrl}/${employee.profile_pic}`
                        : employee.gender === "male"
                        ? Avatar_01
                        : Avatar_02
                    }
                    alt="Employee Avatar"
                  />
                </Link>
                <Link to={`/profile/${employee.empid}`}>{employee.name}</Link>
              </span>
            </td>
            <td className="fixed-column code-column">{employee.empcode}</td>
            {Array.from({ length: daysInMonth }, (_, i) => {
              const day = i + 1;
              const date = moment(
                `${selectedDate.format("YYYY-MM")}-${day}`,
                "YYYY-MM-DD"
              );
              const isWeekend = weekends.includes(date.day());
              const isHoliday = holidays.includes(date.format("YYYY-MM-DD"));

              return (
                <td
                  key={day}
                  className={isWeekend ? "weekend" : isHoliday ? "holiday" : ""}
                  style={{
                    backgroundColor: isWeekend
                      ? "#f0f0f0"
                      : isHoliday
                      ? "#ffeb3b"
                      : "",
                  }}
                >
                  {isHoliday ? (
                    <i className="fa fa-tree text-success" />
                  ) : isWeekend ? (
                    <span>W</span>
                  ) : (
                    <Link
                      to="#"
                      data-bs-toggle="modal"
                      data-bs-target="#attendance_info"
                      onClick={() =>
                        handleDayClick(employee, day, isWeekend, isHoliday)
                      }
                    >
                      <span
                        style={{
                          display: "inline-block",
                          padding: "2px 6px",
                          borderBottom:
                            employee[`day_${day}`] === "-"
                              ? "1px solid red"
                              : "1px solid green",
                          color:
                            employee[`day_${day}`] === "-" ? "red" : "green",
                        }}
                      >
                        {employee[`day_${day}`] === "-" ? "A" : "P"}
                      </span>
                    </Link>
                  )}
                </td>
              );
            })}
            <td>{payrollData.totalDays}</td>
            <td>{payrollData.daysWorked}</td>
            <td>{payrollData.leaves}</td>
            <td>{payrollData.lopDays}</td>
          </tr>
        );
      })}
    </tbody>
  </table>
</div>



                  </>
                )}
              </div>

              {/* Pass the selected employee and day status to the popup */}
              <AttendenceModelPopup
                selectedEmployee={selectedEmployee}
                selectedDay={selectedDay}
                dayStatus={dayStatus}
                onAttendanceSaved={updateAttendanceDataForDay} // Pass the callback function
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AttendanceAdmin;
